import type { JSX } from "react";

/**
 * Für eine App, die der Server anbietet, die diese Oberfläche aber noch nicht kann.
 *
 * Besser als die stille Umleitung auf die Startseite: wer das Symbol anklickt, soll
 * erfahren, woran es liegt, statt zu glauben, der Klick sei nicht angekommen.
 */
export function AppMissingPage({ name }: { name: string }): JSX.Element {
  return (
    <div className="mx-auto max-w-3xl px-6 py-10">
      <h1 className="text-xl font-semibold text-ink">{name}</h1>
      <p className="mt-3 text-sm text-ink-muted">
        Diese App ist auf dem Server freigeschaltet, aber in dieser Oberfläche noch nicht
        enthalten. Nach dem nächsten Ausrollen sollte sie hier erscheinen.
      </p>
    </div>
  );
}
